import QtdModulo from '../../ModulosCrefito/QtdModulo'
import Epi from '../../ModulosCrefito/Modulos/Epi'
import ParametrosAssistenciais from '../../ModulosCrefito/Modulos/ParametrosAssistenciais'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import ResponsavelFisc from '../../ModulosCrefito/Modulos/ResponsavelFisc'
import ProfissionaisNoEstabelecimento from '../../ModulosCrefito/Modulos/ProfissionaisNoEstabelecimento'
import Estagio from '../../ModulosCrefito/Modulos/Estagio'
import NasfModalidades from '../../ModulosCrefito/Modulos/NasfModalidades'
import NasfMunicipio from '../../ModulosCrefito/Modulos/NasfMunicipio'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Nasf = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="MODALIDADE DE NASF-AB" modulo="nafs" />
            <NasfModalidades modulo="nafs" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="responsavelfisc" />
            <ResponsavelFisc modulo="responsavelfisc" />
            <QtdModulo texto="FISIOTERAPEUTAS QUE TRABALHAM NO ESTABELECIMENTO" modulo="profissionais" />
            <ProfissionaisNoEstabelecimento modulo="profissionais" />
            <QtdModulo texto="ATUAÇÃO DO NASF NO MUNICÍPIO" modulo="nasfmunicipio" />
            <NasfMunicipio modulo="nasfmunicipio" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="parametros" />
            <ParametrosAssistenciais modulo="parametros" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="ESTÁGIO" modulo="estagios" />
            <Estagio modulo="estagios" />
            <QtdModulo texto="EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL" modulo="epi" />
            <Epi modulo="epi" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Nasf